import React from 'react';
import { useLayoutContext } from 'contexts/LayoutContext';
import api from 'lib/trpcClient';
import { CurrencyCode } from 'further-types/lp/vehicle';
import TransferLinkedCapitalActionsContent from './TransferLinkedCapitalActionsContent';

const TransferLinkedCapitalActions: React.FC<{
  partnerTransferId: string;
  baseCurrency: CurrencyCode;
  onNext: () => void;
  onPrevious: () => void;
  stepper: React.ReactNode;
}> = ({ partnerTransferId, baseCurrency, onNext, onPrevious, stepper }) => {
  const { selectedVehicleId } = useLayoutContext();

  const [capitalActions] =
    api.partnerTransfers.getLinkedCapitalActions.useSuspenseQuery(
      {
        partnerTransferId,
        vehicleId: selectedVehicleId ?? '',
      },
      {
        staleTime: 0,
        gcTime: 0,
      },
    );

  return (
    <TransferLinkedCapitalActionsContent
      partnerTransferId={partnerTransferId}
      capitalActions={capitalActions ?? []}
      baseCurrency={baseCurrency}
      onNext={onNext}
      onPrevious={onPrevious}
      stepper={stepper}
    />
  );
};

export default TransferLinkedCapitalActions;
